<i18n>
{
  "fr": {
    "getQuotationModal": {
      "title": "Envoyer le projet par mail",
      "submitLabel": "Envoyer le projet",
      "email": "Email du destinataire"
    }
  }
}
</i18n>

<template>
  <BaseModal v-model="isModalActive" class="get-quotation-modal" white>
    <template v-slot:header-content>
      {{ $t('getQuotationModal.title') }}
    </template>

    <form :action="submitUrl" method="POST" @submit="submitting = true">
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" name="new_cart" :value="1" />

      <div class="label-input">
        <label
          for="quotation_mail"
          class="label-input__label label-input__label required"
        >
          {{ $t('getQuotationModal.email') }}
        </label>
        <input
          id="quotation_mail"
          v-model="value"
          type="email"
          name="email"
          data-vv-as="'Email'"
          class="label-input__input control"
          aria-required="true"
          aria-invalid="false"
          required
          placeholder="utilisateur@email.com"
        />
      </div>

      <ModalSubmitButton
        class="get-quotation-modal__button"
        :disabled="submitting"
        :submit-button-label="$t('getQuotationModal.submitLabel')"
      />
    </form>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal';
import ModalSubmitButton from '../Modals/ModalSubmitButton';
import Modal from '../../mixins/Modal';

export default {
  name: 'GetQuotationModal',
  components: { BaseModal, ModalSubmitButton },
  mixins: [Modal],
  props: {
    email: {
      type: String,
      default: null,
    },
    submitUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      submitting: false,
      value: this.email,
      csrf: document.head.querySelector('meta[name="csrf-token"]').content,
    };
  },
  computed: {
    isModalActive: {
      get() {
        return window.modalStateObservable.isGetQuotationModalActive;
      },
      set(v) {
        window.modalStateObservable.isGetQuotationModalActive = v;
      },
    },
  },
  methods: {
    closeModal() {
      this.isModalActive = false;
    },
  },
};
</script>

<style scoped lang="scss">
$base-modal: '.base-modal';
.get-quotation-modal {
  &::v-deep #{$base-modal} {
    &__container {
      width: px2em(490px);
      max-width: px2em(490px);
    }
  }

  &__button {
    margin-top: 1em;
  }
}
</style>
